import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CodeNsfResponse } from '@features/referentiel/models/response';
import { DispositifConfig } from '@features/referentiel/config/dispositif.config';

@Injectable({
    providedIn: 'root',
})
export class CodeNsfService {
    constructor(private http: HttpClient) { }

    getAllCodesNsf(): Observable<CodeNsfResponse> {
        return this.http.get<CodeNsfResponse>(DispositifConfig.codesNsfList);
    }
}
